import CanvasHandler from "./CanvasHandler";
import { Seat, Table } from "../canvas/blocker";
import { FabricEvent } from "../types/FabricCustomType";
import { IObjectBlocker } from "../types/HandlerObjectType";
import { isTouchInteraction } from "../utils/InteractionUtil";
import BaseObjectHandler from "./BaseObjectHandler";
import { ObjectSuperTypesEnum, SelectionTypeEnum } from "../enums";
import store from "../redux/store";
import { setSpinning } from "../redux/designerPropertiesSlice";

class BlockerHandler extends BaseObjectHandler<IObjectBlocker> {
  constructor(canvasHandler: CanvasHandler) {
    super(canvasHandler);
    this.objectTypes = {
      seat: new Seat(canvasHandler),
      table: new Table(canvasHandler),
    };
  }

  public setType(type: string) {
    if (this.object && this.selectedType !== type) this.object.deactivateObjectHover();
    super.setType(type);
  }

  public handleClickObject(event: FabricEvent<MouseEvent | TouchEvent>) {
    const isTouch = isTouchInteraction(event);
    if (event.target) {
      const { target: { superType } } = event;
      switch (superType) {
        case ObjectSuperTypesEnum.Row:
        case ObjectSuperTypesEnum.RoundTable:
        case ObjectSuperTypesEnum.RectTable:
          const byTable = event.target.selectionType === SelectionTypeEnum.byTable;
          const seat = byTable
            ? event.target._objects.find((t: any) => t?.superType === ObjectSuperTypesEnum.Table)
            : event.subTargets?.find((t: any) => t?.superType === ObjectSuperTypesEnum.Seat);
          if (seat) {
            this.setType(seat.superType);
            if (isTouch) {
              this.object.activateObjectHover(event, seat);
            } else {
              this.object.handleSelectObject(event, event.target.id, seat);
            }
          }

          break;
        default:
          if (isTouch) this.deactivateObjectHover();
          break;
      }
    } else {
      if (isTouch) this.deactivateObjectHover();
    }
  }

  public async handleSelectObjects(event: FabricEvent) {
    this.deactivateObjectHover();
    for (const blocker of Object.values(this.objectTypes)) {
      await blocker.handleSelectObjects(event);
    }
  }

  public async handleSaveChanges() {
    store.dispatch(setSpinning(true));
    try {
      for (const blocker of Object.values(this.objectTypes)) {
        await blocker.handleSaveChanges();
      }
    } finally {
      store.dispatch(setSpinning(false));
    }
  }
}

export default BlockerHandler;
